<template>
  <b-container fluid>
    <b-row class="my-3">
      <b-col class="d-flex">
        <b-button @click="loadReportFixedPackages" class="b-report mx-3" variant="success" type="button">
          <b-spinner v-if="visible" small type="grow" class="mr-3"></b-spinner>Загрузить отчет
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'ReportFixedPackages',
  computed: {
    ...mapState(
      {
        visible: state => state.statistic.visible
      }
    )
  },
  methods: {
    ...mapActions('statistic',
      [
        'loadReportFixedPackages'
      ]
    )
  }
}
</script>

<style scoped>

</style>
